export const updateConsent = () => {
  const hasConsentUpdate =
    Array.isArray(window.dataLayer) &&
    window.dataLayer.some(
      item =>
        Array.isArray(item) && item[0] === 'consent' && item[1] === 'update'
    )

  if (!hasConsentUpdate && typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    })

    window.dataLayer.push({ event: 'consent_granted' })
    window.dataLayer.push({ event: 'gatsby-route-change' })
  }
}
